import { combineValidateRules } from 'legacy/lut/helpers/combineValidateRules'
import { useCallback, useMemo } from 'react'

import { ValidatedByCountryFields } from 'clickNgo/configs/validation'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { checkTaxIdDuplication } from 'clickNgo/helpers/validation'
import { useValidateByCountry } from 'clickNgo/hooks/validation'

interface IUseTaxIdValidate {
  country: string
  hierarchyType: PartnerHierarchyType
}

export const useTaxIdValidate = ({ country, hierarchyType }: IUseTaxIdValidate) => {
  const [validateFn, isTaxIdRequired] = useValidateByCountry({
    countryName: country,
    field: ValidatedByCountryFields.TAX_ID,
  })

  const checkTaxId = useCallback(
    async (taxId: string) => checkTaxIdDuplication({ taxId, hierarchyType }),
    [hierarchyType]
  )

  const onTaxIdValidate = useMemo(() => {
    return combineValidateRules([validateFn, checkTaxId])
  }, [checkTaxId, validateFn])

  return { onTaxIdValidate, isTaxIdRequired }
}
